module.exports = (__webpack_require__(35056))(4843);